<template>
  <table>
    <tr>
      <th class="pr-1">
        <label for="status-selector" class="mb-0">Status</label>
      </th>
      <td class="pr-5">
        <b-form-select
          id="status-selector"
          v-model="statusLocal"
          :options="statusOptions"
        />
      </td>

      <th class="pr-1">
        <label for="window-past-duration-selector" class="mb-0">Past</label>
      </th>
      <td class="pr-3">
        <b-form-select
          id="window-past-duration-selector"
          v-model="periodWindow.pastDuration"
          :options="durationOptions"
        />
      </td>

      <th class="pr-1">
        <label for="window-future-duration-selector" class="mb-0">Future</label>
      </th>
      <td>
        <b-form-select
          id="window-future-duration-selector"
          v-model="periodWindow.futureDuration"
          :options="durationOptions"
        />
      </td>
    </tr>
  </table>
</template>

<script>
import { getEventStatusOptionsForFilter } from '../model/event_status.js';
import { getWindowDurationOptions       } from '../model/event_time_filter.js';

export default {
  name: 'EventFilter',

  props: {
    status: {
      type: Number,
    },

    periodWindow: {
      type: Object,
      required: true,
    },
  },

  computed: {
    durationOptions() {
      return getWindowDurationOptions();
    },

    statusOptions() {
      return getEventStatusOptionsForFilter();
    },

    statusLocal: {
      get: function() {
        return this.status;
      },

      set: function(newValue) {
        this.$emit('status-update-requested', newValue)
      },
    },
  },
};
</script>
